// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011504/js/" + chunkId + "." + {"44":"aeee58a6","225":"48fea1d5","481":"b3cb8930","486":"846cafda","770":"27ba7e26"}[chunkId] + ".0.5230954532009979.chunk.js";
};